module.exports = __webpack_public_path__ + "img/poster.f4fa8c94.png";